<script>
  import AdGroupEditor from './AdGroupEditor.vue'
  import { getAdGroupDetailInfo } from '@/api/marketing/adGroup'

  export default {
    name: 'AdGroupPage',
    components: {
      AdGroupEditor
    },
    data() {
      return {
        loading: false,
        adGroupId: null,
        adGroupData: null,
        isEdit: false
      }
    },
    computed: {
      pageTitle() {
        return this.isEdit ? '编辑广告组' : '新增广告组'
      }
    },
    created() {
      // 从路由参数获取广告组ID
      this.adGroupId = this.$route.params.id

      // 如果有ID，则为编辑模式
      if (this.adGroupId) {
        this.isEdit = true
        this.fetchAdGroupData()
      }
    },
    methods: {
      // 获取广告组数据
      async fetchAdGroupData() {
        try {
          this.loading = true
          const res = await getAdGroupDetailInfo(this.adGroupId)

          if (res.code === 0) {
            this.adGroupData = res.data
          } else {
            this.$message.error(res.message || '获取广告组数据失败')
          }
        } catch (error) {
          console.error('获取广告组数据失败:', error)
          this.$message.error('获取广告组数据失败')
        } finally {
          this.loading = false
        }
      },

      // 处理成功提交
      handleSuccess() {
        this.$message.success(this.isEdit ? '广告组编辑成功' : '广告组创建成功')
        // 使用replace替换当前页面在历史记录中的位置，而不是添加新记录
        this.$router.replace('/FooterBannerList')
      }
    }
  }
</script>

<template>
  <div class="ad-group-page">
    <div class="page-header">
      <div class="page-title">{{ pageTitle }}</div>
      <div class="page-actions">
        <el-button icon="el-icon-back" @click="$router.go(-1)">返回</el-button>
      </div>
    </div>

    <div class="page-content">
      <el-skeleton :loading="isEdit && loading" animated>
        <template slot="template">
          <div style="padding: 20px">
            <el-skeleton-item variant="text" style="width: 30%; height: 40px" />
            <div style="display: flex; margin-top: 20px">
              <div style="width: 70%">
                <el-skeleton-item variant="text" style="margin-bottom: 10px; height: 30px" />
                <el-skeleton-item variant="text" style="margin-bottom: 10px; height: 30px" />
                <el-skeleton-item variant="text" style="margin-bottom: 10px; height: 30px" />
              </div>
              <div style="width: 30%">
                <el-skeleton-item variant="image" style="width: 100%; height: 200px" />
              </div>
            </div>
          </div>
        </template>

        <template>
          <AdGroupEditor
            :edit-data="adGroupData"
            :is-edit="isEdit"
            :is-simple-mode="false"
            @success="handleSuccess"
          />
        </template>
      </el-skeleton>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .ad-group-page {
    padding: 20px;

    .page-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .page-title {
        font-size: 18px;
        font-weight: 500;
      }
    }

    .page-content {
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
  }
</style>
